<template>
  <b-card
    no-body
    class="card-developer-meetup"
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        :src="imgLogoFull"
        fluid-grow
      />
    </div>
    <b-card-body>
      <div class="meetup-header d-flex align-items-center mb-0">
        <div class="meetup-day">
          <h6 class="mb-0">
            {{ dayFullName(today) }}
          </h6>
          <h3 class="mb-0">
            {{ today.getDate() }}
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title
            v-if="area"
            class="mb-25"
          >
            {{ area.areaName }}
          </b-card-title>
          <b-card-text class="mb-0">
            {{ fullName }}
          </b-card-text>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'
import { $themeConfig } from '@themeConfig'
import {
  BCard, BImg, BCardBody, BCardText, BCardTitle,
} from 'bootstrap-vue'

const { appDir } = $themeConfig.app

export default {
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,

  },
  props: {
    area: {
      type: Object,
      default: null,
    },
    fullName: {
      type: String,
      default: null,
    },
  },
  data() {
    /* eslint-disable import/no-dynamic-require */
    /* eslint-disable global-require */
    return {
      today: new Date(),
      imgLogoFull: null,
    }
  },
  mounted() {
    this.$watch('area', () => {
      this.imgLogoFull = require(`@/assets/images/logo/${appDir}/logo-full${this.area.areaPrefix ? `_${this.area.areaPrefix}` : ''}.png`)
    }, { immediate: true })
  },
  methods: {
    dayFullName(date) {
      moment.locale('it')
      return moment(date).format('dddd')
    },
  },
}
</script>
